import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroBadges, heroImage, trustStats } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-night" data-id="element-113" data-mp="9ipchchyjg0n">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'linear-gradient(to right, #f7f2e8 1px, transparent 1px), linear-gradient(to bottom, #f7f2e8 1px, transparent 1px)',
      backgroundSize: '72px 72px'
    }} data-id="element-114" data-mp="4n1kyqg06arz" />

      <div className="relative mx-auto max-w-content px-6 py-10 lg:py-16" style={{
      paddingTop: "0px"
    }} data-id="element-115" data-mp="sa9qn9hcfluj">
        

        <div className="mt-10 grid items-center gap-10 lg:mt-16 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-116" data-mp="nbey3ftkqix8">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-center lg:text-left" data-id="element-117" data-mp="3d33eqyadctkr">
            <p className="font-sans text-sm font-semibold uppercase tracking-[0.18em] text-gold-soft" data-id="element-118" data-mp="3j6odfogqqus7">
              🙏 GPS Bíblico™
            </p>
            <h1 className="mt-5 font-display text-[2.6rem] font-semibold leading-[1.05] tracking-tight text-parchment sm:text-6xl lg:text-[4rem]" data-id="element-119" data-mp="399bavmrkdbvg">
              Comprendé la Biblia Católica.
              <span className="mt-2 block text-gold-soft" data-id="element-120" data-mp="30hre366hlc34">Desde hoy. Sin perderte.</span>
            </h1>

            <p className="mx-auto mt-6 max-w-xl font-sans text-lg font-semibold leading-snug text-gold-soft lg:mx-0" data-id="element-121" data-mp="359szpipjof5t">
              La ruta visual de los 73 libros — Antiguo y Nuevo Testamento — para entender
              el propósito de cada libro en menos de 60 segundos.
            </p>
            <p className="mx-auto mt-4 max-w-xl font-sans text-base leading-relaxed text-parchment/70 lg:mx-0" data-id="element-122" data-mp="2hix224yeqpqn">
              Un mapa mental por libro, con su contexto y su lugar en la Historia de la
              Salvación. Abrís, navegás, entendés. Sin buscar en internet.
            </p>

            <ul className="mt-7 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-123" data-mp="natb7mfw54pz">
              {heroBadges.map(badge => <li key={badge} className="rounded-full border border-night-line bg-night-panel px-3 py-1.5 font-sans text-xs font-medium text-parchment/75" data-id="element-124" data-mp="id9v0gzmuhve">
                  {badge}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-125" data-mp="1b0du65c1o1z9">
              <CtaButton size="block" className="sm:w-auto sm:px-10" data-id="element-126" data-mp="161t2iuauyqmf">
                🙏 Quiero mi GPS Bíblico ahora
              </CtaButton>
              <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 font-sans text-sm text-parchment/60 lg:justify-start" data-id="element-127" data-mp="111omf5dv3xwq">
                <li className="flex items-center gap-2" data-id="element-128" data-mp="x3h0lw4jk6eo">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-129" data-mp="3ltqclcptivti" />
                  Garantía 7 días
                </li>
                <li className="flex items-center gap-2" data-id="element-130" data-mp="1x9b4gyotkxbi">
                  <CreditCardIcon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-131" data-mp="1xavz0ob4wg9d" />
                  Pago seguro
                </li>
                <li className="flex items-center gap-2" data-id="element-132" data-mp="269zhpr6e2tnc">
                  <ZapIcon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-133" data-mp="268g1u1onakm3" />
                  Acceso al instante
                </li>
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-134" data-mp="2fzaoh75szm82">
            <img src={heroImage} alt="Portada de GPS Bíblico: la ruta visual de los 73 libros de la Biblia Católica" className="mx-auto h-auto w-full max-w-sm rounded-2xl object-contain shadow-2xl" data-id="element-135" data-mp="2oye8qegpi7o5" />
          </motion.div>
        </div>
      </div>

      <div className="relative border-t border-night-line bg-night-panel" data-id="element-136" data-mp="zl12gjp1a9ke">
        <dl className="mx-auto grid max-w-content grid-cols-2 gap-y-8 px-6 py-8 lg:grid-cols-4" data-id="element-137" data-mp="4bdx7gy3ybp5">
          {trustStats.map(stat => <div key={stat.label} className="text-center" data-id="element-138" data-mp="3vi714skacoxd">
              <dt className="sr-only" data-id="element-139" data-mp="3vk1k41bzy6yt">{stat.label}</dt>
              <dd data-id="element-140" data-mp="e8innsyzktbr">
                <span className="block font-display text-3xl font-semibold text-gold-soft" data-id="element-141" data-mp="e91vgguxa1c2">
                  {stat.value}
                </span>
                <span className="mt-1 block font-sans text-sm text-parchment/60" data-id="element-142" data-mp="3hq0sdrjgpk7y">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}